/**
 * Public entry for the VIP Chat widget.
 *
 * Two ways to consume:
 *  1) Web Component (recommended for non-React hosts):
 *       <script src=".../chat-widget.umd.js"></script>
 *       <vip-chat token="..." server-url="https://chat.example.com"></vip-chat>
 *
 *  2) React component (for React hosts):
 *       import { VipChat } from '@vip-chat/widget';
 *       <VipChat token={...} serverUrl={...} />
 */
import './styles.css';
import { defineWebComponent } from './web-component';

// Auto-register the custom element when loaded as a script (UMD).
if (typeof window !== 'undefined' && !customElements.get('vip-chat')) {
  defineWebComponent();
}

export { VipChat } from './components/VipChat';
export { defineWebComponent } from './web-component';
export type { VipChatProps } from './components/VipChat';
